import { track } from "@amplitude/analytics-react-native";
import { memo } from "react";
import { View } from "react-native";
import GenerateAiPhotoEditDocument from "src/api/graphql/__generated__/documents/GenerateAiPhotoEditDocument";
import soloPng from "src/assets/images/solo.png";
import PillButton from "src/components/PillButton";
import { useGatheringStore } from "src/contexts/GatheringContext";
import { useModal } from "src/modals";
import InternalModal from "src/modals/configs/InternalModal";
import usePhotoDetailStore from "src/screens/(internal)/PhotoDetailModal/stores/usePhotoDetailStore";
import { getCurTime_S } from "src/shared/helpers/timeHelpers";
import useGlobalStore, { getGlobalStore } from "src/stores/useGlobalStore";
import { alert, Image } from "src/swsh-native";

const PhotoDetailFratifyMeButton = () => {
	const gatheringId = useGatheringStore((state) => state.gatheringId);
	const { presentModal } = useModal<InternalModal>();

	return (
		<View>
			<PillButton
				CustomIcon={
					// Mocking space for image
					<View
						style={{
							width: 48,
							height: 1,
						}}
					/>
				}
				textProps={{
					semibold: true,
				}}
				onPress={() => {
					track("imageGen_fratifyMe_press");
					const { photoGenAIConsentedAt } = getGlobalStore();
					const handleConfirmAction = () => {
						const { photoGenAIConsentedAt } = getGlobalStore();
						track("imageGen_fratifyMe_confirm", {
							photoGenAIConsentedAt,
						});
						const { apolloClient } = getGlobalStore();
						if (!apolloClient) return;
						const photo = usePhotoDetailStore.getState().curPhoto;
						if (!photo) return;
						const promise = apolloClient.mutate({
							mutation: GenerateAiPhotoEditDocument,
							variables: {
								input: {
									photoId: photo?.photoId,
									gatheringId,
								},
							},
							context: {
								pinBehavior: "inert",
							},
						});
						presentModal("ImageGeneration", {
							props: {
								imagePromise: promise.then((result) => {
									const imageUrl = result.data?.generateAIPhotoEdit?.imageUrl;
									if (!imageUrl) {
										throw new Error("Failed to fratify photo");
									}
									return {
										imageUrl,
									};
								}),
								bottomLoadingText: [
									"This may take up to 30 seconds",
									"Refresh the album to see results",
								],
								loadingBlurbs: [
									"Shotgunning a rack of beers...",
									"Loading up the keg...",
									"Flipping red solo cups...",
									"So blessed I’d be greedy if I sneezed...",
									"Didn’t need a gender reveal, they knew I was him...",
									"Bad day to be a beer...",
									"Body so tea, Boston had a party...",
									"GPS said it’s my turn...",
									"Peed my pants explains the drip...",
									"They call me tori vega the way I stay victorious...",
									"Ring camera says motion detected...",
									"Call the chiropractor, I’m back...",
									"Don't worry about dinner, I ate...",
									"Call me ranch the way I be dressin...",
									"Feeling myself like I lost my keys...",
									"Disney called cause they know these Pixar fire...",
									"Standing on toilet paper cus I'm tha shit...",
									"In my prime, but no delivery...",
								],
							},
						});
					};
					if (photoGenAIConsentedAt) {
						handleConfirmAction();
					} else {
						alert({
							title: "Fratify Me ✨",
							message:
								"Your frat pic will be uploaded to the album for you. By using this feature, you agree to the usage of generative AI to create a derived work of requested photos.",
							buttons: [
								{
									style: "cancel",
									text: "Cancel",
									onPress: () => {
										track("imageGen_fratifyMe_cancel");
									},
								},
								{
									style: "default",
									text: "Do it!",
									isPreferred: true,
									onPress: () => {
										track("imageGen_fratifyMe_agree");
										useGlobalStore.setState({
											photoGenAIConsentedAt: getCurTime_S(),
										});
										handleConfirmAction();
									},
								},
							],
						});
					}
				}}
			>
				Fratify
			</PillButton>
			<Image
				pointerEvents="none"
				alt="Solo cup"
				src={soloPng}
				dim={{
					width: 48,
					height: 48,
				}}
				style={{
					top: -6,
					position: "absolute",
				}}
				contentFit="contain"
				contentPosition="right"
			/>
		</View>
	);
};
export default memo(PhotoDetailFratifyMeButton);
